import ApiService from "../../ApiService";
import React, { Component, Fragment } from "react";
import DispatchProps from "../../../utils/DispatchProps";
import OnboardHelpBox from "./OnboardHelpBox";
import OnboardTimeline, {OnboardTimelineItem} from "./OnboardTimeline";
import OnboardNavigation from "./OnboardNavigation";
import { IRootState } from "../../../store";
import { connect } from "react-redux";
import { History } from "history";
import MoveToNextOnboardState  from "./MoveToNextOnboardState";
import School from "../../../models/School";

interface OnboardMoveToNextStatePageProps {
    tenantId: string;
    schoolCode: string;
    timelineItemKey: string;
    
    buttonText: string;
    helpText: string;   

    apiService: ApiService;
    history: History;
}

interface OnboardMoveToNextStatePageState {
}

class OnboardMoveToNextStatePage extends Component<OnboardMoveToNextStatePageProps & DispatchProps, OnboardMoveToNextStatePageState> {

    constructor(props: OnboardMoveToNextStatePageProps & DispatchProps) {
        super(props);
        this.state = {
        };
    }

    async componentDidMount(): Promise<void> {
    }

    async componentDidUpdate(prevProps: Readonly<OnboardMoveToNextStatePageProps & DispatchProps>, prevState: any): Promise<void> {
    }

    private save = async (): Promise<boolean> => {
        return true;
    }

    public render(): JSX.Element {
        return (
            <Fragment>
                <OnboardHelpBox currentTimelineItemKey={this.props.timelineItemKey}/>
                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                <MoveToNextOnboardState
                                    schoolCode={this.props.schoolCode}
                                    tenantId={this.props.tenantId}
                                    buttonText={this.props.buttonText}
                                    history={this.props.history}
                                    helpText={this.props.helpText}
                                />
                                <OnboardNavigation currentTimelineItemKey={this.props.timelineItemKey} timelineItems={timelineItems} completeItem={this.save} enableNext={false} enableSave={false} history={this.props.history} tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                            </Fragment>
                        );
                    }}
                </OnboardTimeline>
                
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardMoveToNextStatePageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            timelineItemKey: ownProps.timelineItemKey,
            buttonText: ownProps.buttonText,
            helpText: ownProps.helpText,
            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(OnboardMoveToNextStatePage)